<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>公司汽车违章处理结果使用说明:<br>
					<span>1、单号构成规则:201201+WZ+4位顺序号。系统生成,添加无效</span><br>
					<span>2、自动从违章登记里读取未处理的信息,提交后表示完成</span><br>
					<span class="red">3、提交后才算处理完毕</span><br>
					<span>4、查询关键字:略。</span><br>

				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>

	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1_new.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''

			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// //事故附件操作老方法 carWZover
				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '汽车违章审核',
					"control": "carViolationOver",
					"isTwo": "1",
					"action_flag": "long",
					"sel_action_flag": "more", //更多查询
					"isFileMain": "1",
					"sel_action": 'exp_carViolover',
					"upd_action": 'exp30_car_carVio_over',
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": 'filemore',
					"p1": 'car',
					"p2": 'over',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "data_exp_car",
							"sel_name": "",
							"sel": "2",
							"sel_more": "A_to",
						},
						{
							"name": "车挂别名",
							"val": "",
							"key": "cp_no",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "_base_car_bm",
							"sel_name": "",
							"sel_more": "A",
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "4"
						},
						{
							"name": "违章日期起始",
							"val": "",
							"key": "s_c_date",
							"type": "date",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "违章日期终止",
							"val": "",
							"key": "e_c_date",
							"type": "date",
							"class": "long1",
							"sel": "6"
						},
						{
							"name": "开始修改时间",
							"val": "",
							"key": "s_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "7"
						},
						{
							"name": "截止修改时间",
							"val": "",
							"key": "e_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "8"
						},
						{
							"name": "司机",
							"val": "",
							"key": "c_driver",
							"type": "text",
							"class": "long1",
							"sel": "9"
						},
						{
							"name": "汽车分类",
							"val": "",
							"key": "carclass",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_carclass",
							"sel_name": "",
							"sel": "10"
						},
						{
							"name": "违章消除",
							"val": "",
							"key": "v_flag",
							"type": "select",
							"class": "long1",
							"list": [{
								"id": "1",
								"val": "待处理"
							}, {
								"id": "2",
								"val": "已消除"
							}],
							"sel_val": {},
							"sel_name": "",
							"sel": "11"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "车挂别名",
							"val": "",
							"key": "cp_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "汽车分类",
							"val": "",
							"key": "carclass",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "罚单编号",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "违章日期",
							"val": "",
							"key": "c_date",
							"type": "datetime",
							"class": "long2",
							"weight": "1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},

						{
							"name": "司机",
							"val": "",
							"key": "c_driver",
							"type": "text",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "跟车员",
							"val": "",
							"key": "c_tail",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "货物名称",
							"val": "",
							"key": "c_thing",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "违章地点",
							"val": "",
							"key": "c_addr",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "违章详情",
							"val": "",
							"key": "c_data",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "扣分",
							"val": "0",
							"key": "c_num",
							"type": "number",
							"class": "long1",
							"weight": "1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "罚款金额",
							"val": "0",
							"key": "v_fee",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "消分费用",
							"val": "0",
							"key": "v_fee_num",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "滞纳金",
							"val": "0",
							"key": "v_fee_late",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "总费用",
							"val": "",
							"key": "c_amount",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "司机承担",
							"val": "",
							"key": "v_fee_user",
							"type": "number",
							"class": "long1",
							"note": "司机承担费用",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "处理结果",
							"val": "1",
							"key": "v_flag",
							"type": "radio",
							"list": [{
								"id": "1",
								"val": "待处理"
							}, {
								"id": "2",
								"val": "已消除"
							}],
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "5"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "6"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_name",
							"type": "selectnew",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "6"

						},
						{
							"name": "审核备注",
							"val": "",
							"key": "pass_note",
							"type": "textarea",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "7"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "关联业务"
						},
						{
							"name": "状态"
						},
						{
							"name": "是否消除"
						},
						{
							"name": "车牌号码"
						},
						{
							"name": "别名"
						},
						{
							"name": "汽车归类"
						},
						{
							"name": "罚单编号"
						},
						{
							"name": "登记凭证"
						},
						{
							"name": "罚单日期"
						},
						{
							"name": "总金额"
						},
						{
							"name": "违章司机"
						},
						{
							"name": "违章跟车员"
						},
						{
							"name": "货物名称"
						},
						{
							"name": "违章地址"
						},
						{
							"name": "违章详情"
						},
						{
							"name": "附件"
						},
						{
							"name": "扣分"
						},
						{
							"name": "罚款金额"
						},
						{
							"name": "消分费用"
						},
						{
							"name": "滞纳金"
						},
						{
							"name": "司机承担费用"
						},

						{
							"name": "备注"
						},
						{
							"name": "违章备注"
						},
						{
							"name": "经办人"
						},
						{
							"name": "修改人"
						},
						{
							"name": "地址1"
						},
						{
							"name": "地址2"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},


		}
	};
</script>
<style scoped>
	.pre_dataintable td:nth-child(5) {
		min-width: 120px;
	}
</style>